// extracted by mini-css-extract-plugin
export var carrierIcon = "_yu-0";
export var carrierLogo = "_yu-1";
export var detailsSection = "_yu-2";